// import axios from "axios";
import { useMutation, useQuery } from "react-query";
// import {
//   deleteFromStorage,
//   getFromStorage,
//   saveToStorage,
// } from "../../utils/storage";
// import { useHistory } from "react-router-dom";
// import api from "./axiosInterceptor";
import apiClient from "./newAxiosInterceptor";

const fetchEntries = async (url) => {
  const response = await apiClient.get(url);
  return response;
};

export const FetchData = (name, endpoint, action) => {
  return useQuery(
    [name, endpoint],
    async () => {
      try {
        return fetchEntries(endpoint);
      } catch (error) {
        throw error;
      }
    },
    {
      ...action,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );
};

export const PostData = (slug, method, action) => {
  return useMutation((payload) => {
    return apiClient({
      method: method,
      url: slug,
      data: payload,
    });
  }, action);
};

// const refreshToken = async (refreshToken) => {
//   const baseURL = "https://mazudsbeap02.azurewebsites.net/api/v1/";

//   try {
//     const response = await axios.post(`${baseURL}User/RefreshSignIn`, {
//       refreshToken,
//     });
//     saveToStorage("user_data", response.data?.data);
//     return response.data?.access_token;
//   } catch (error) {
//     throw new Error("Failed to refresh token");
//   }
// };

//***********get Api Call**********//

//***********get Api Call**********//

// const fetchEntries = async (url, token) => {
//   // const response= await axios(url, {
//   //   headers: {
//   //     Authorization: `Bearer ${token}`,
//   //   },
//   // });
//   // return response;
//   try {
//     const response = await axios(url, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return response;
//   } catch (error) {
//     // Handle specific errors here
//     throw error;
//   }
// };

//get APi call
// export const FetchData = (name, url, action) => {
//   return useQuery(name, () => fetchEntries(url), {
//     ...action,
//     refetchOnWindowFocus: false,
//     retry:false,
//   });
// };

//get APi call
// export const FetchData = (name, url, action) => {
//   const history = useHistory();

//   const { data, ...queryInfo } = useQuery(
//     name,
//     async () => {
//       try {
//         const token =
//           getFromStorage("user_token") ||
//           getFromStorage("user_data")?.access_token;
//         const response = await fetchEntries(url, token);
//         return response;
//       } catch (error) {
//         if (error.response && error.response.status === 401) {
//           try {
//             await refreshToken(getFromStorage("user_data")?.refresh_token);
//             // Retry the query after refreshing the token
//             return await fetchEntries(
//               url,
//               getFromStorage("user_data")?.access_token
//             );
//           } catch (refreshError) {
//             // Handle token refresh failure
//             // deleteFromStorage("user_data");
//             // history.push("/login");
//             throw refreshError;
//           }
//         } else {
//           throw error;
//         }
//       }
//     },
//     {
//       ...action,
//       refetchOnWindowFocus: false,
//       retry: false,
//     }
//   );

//   return { data, ...queryInfo };
// };

// export const FetchData = (name, endpoint, action) => {
//   return useQuery(
//     [name, endpoint],
//     async () => {
//       try {
//         return fetchEntries(endpoint);
//       } catch (error) {
//         // Handle the error here
//         throw error;
//       }
//     },
//     { ...action,
//       refetchOnWindowFocus: false,
// //     retry:false
//     }
//   );
// }

// const fetchEntries = (url) => {
//   const token = getFromStorage('user_token') || getFromStorage('user_data')?.access_token;
//   return api(url, {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
// };

// //get APi call
// export const FetchData = (name, url, action) => {
// const history = useHistory()

//   const { data, ...queryInfo } = useQuery(name, () => fetchEntries(url), {
//     ...action,
//     refetchOnWindowFocus: false,
//     retry:false,
//     // onError: async (error) => {

// if (error.response && error.response.status === 401) {
//   try {
//     const accessToken = await refreshToken(getFromStorage('user_data')?.refresh_token);
//     queryInfo.refetch();
//   } catch (error) {
//     // Handle token refresh failure
//     deleteFromStorage("user_data")
//     // history.push("/login")
//   }
// }
//     // },
//   });
//   return { data, ...queryInfo };
// };

//***********post Api call**********//

// export const PostData = (slug, method, action) => {
//   const token = getFromStorage("user_data")?.access_token;

//   return useMutation((payload) => {
//     return axios({
//       method: method,
//       url: slug,
//       data: payload,
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//   }, action);
// };
